export default "__VITE_ASSET__b2be80ea__"